import { jsx as _jsx } from "react/jsx-runtime";
import { useMutation, useApolloClient } from '@apollo/client';
import { CREATE_REACTION, DELETE_REACTION, SOCIAL_INTERACTION_TARGET_FRAGMENT, } from '../graphql';
import { getSocialTrackingMetaData } from '../..';
import { LikeButton } from './like-button';
export const LikeReactionButton = ({ backendTrackingMetaData = { trackingTokens: [], page: '', position: '' }, hasLike, label, onCompleted = () => { }, onError = () => { }, propSocialInteractionId, urn, ...props }) => {
    const MUTATION = hasLike ? DELETE_REACTION : CREATE_REACTION;
    const apollo = useApolloClient();
    const [reactionsMutation, { loading }] = useMutation(MUTATION, {
        onError,
        onCompleted,
    });
    const handleOptimisticUpdate = () => {
        const id = `SocialInteractionTarget:${urn}`;
        const interactions = apollo.readFragment({
            id,
            fragment: SOCIAL_INTERACTION_TARGET_FRAGMENT,
        });
        const nextInteraction = interactions.userReactionType
            ? {
                ...interactions,
                userReactionType: null,
                reactionsCount: interactions.reactionsCount === 0
                    ? 0
                    : interactions.reactionsCount - 1,
            }
            : {
                ...interactions,
                userReactionType: 'LIKE',
                reactionsCount: interactions.reactionsCount + 1,
            };
        apollo.writeFragment({
            id,
            fragment: SOCIAL_INTERACTION_TARGET_FRAGMENT,
            data: nextInteraction,
        });
    };
    const handleOnClick = () => {
        if (!loading) {
            handleOptimisticUpdate();
            reactionsMutation({
                variables: {
                    urn,
                    ...(hasLike
                        ? {}
                        : getSocialTrackingMetaData({
                            propSocialInteractionId,
                            backendTrackingMetaData,
                        })),
                },
            });
        }
    };
    return (_jsx(LikeButton, { label, hasLike, onClick: handleOnClick, ...props }));
};
//# sourceMappingURL=like-reaction-button.js.map